// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* some helper classes to Box component */\n.max-width[data-v-7aac34c0] {\n\twidth: 100%;\n\tmax-width: var(--max-screen-width);\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tpadding-left: 40px;\n\tpadding-right: 40px;\n}\n.full-width[data-v-7aac34c0] {\n\tpadding-left: 40px;\n\tpadding-right: 40px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
